import React, { useEffect, useState } from "react";
import axios from "axios";
import { Base_URL } from "../url";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../Context/AuthContext";
import { createPortal } from "react-dom";
import "../Styling/VendorInvoiceList.css";
import { FaChevronDown } from "react-icons/fa";

export default function VendorInvoicesList() {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const [expanded, setExpanded] = useState({});
  const [itemsLoading, setItemsLoading] = useState({});
  const [posting, setPosting] = useState({});
  const [gstData, setGstData] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [reversing, setReversing] = useState(false);
  const [searchInvoice, setSearchInvoice] = useState("");
  const [searchVendor, setSearchVendor] = useState("");
  const [postedFilter, setPostedFilter] = useState("");
  const [reversedFilter, setReversedFilter] = useState("");
  const [invoiceTypeFilter, setInvoiceTypeFilter] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
const [archiving, setArchiving] = useState({});
  const { user } = useAuth();
const [showArchived, setShowArchived] = useState(false);
const [unarchiving, setUnarchiving] = useState({});
useEffect(() => {
  if (user?.userId) {
    loadInvoices();
  }
}, [showModal, user?.userId]);
  const loadInvoices = async () => {
  try {
    setLoading(true);

    const resp = await axios.get(
      `${Base_URL}/VendorInvoice/GetVendorInvoiceHeader/${user?.userId}`
    );

    setInvoices(Array.isArray(resp.data) ? resp.data : []);
    setError(null);
  } catch (err) {
    console.error(err);
    setError("Failed to load vendor invoices");
    toast.error("Failed to load vendor invoices");
  } finally {
    setLoading(false);
  }
};
const handleArchive = async (vendorInvoiceNumber) => {
  try {
    setArchiving((prev) => ({
      ...prev,
      [vendorInvoiceNumber]: true,
    }));

    await axios.put(
      `${Base_URL}/BalanceSheet/archiveVendorInvice?id=${encodeURIComponent(
        vendorInvoiceNumber
      )}&userId=${user?.userId}`
    );

    toast.success(`Invoice ${vendorInvoiceNumber} archived successfully`);

    // Refresh the list from API
    await loadInvoices();
  } catch (err) {
    toast.error(
      err.response?.data ||
      `Failed to archive invoice ${vendorInvoiceNumber}`
    );
  } finally {
    setArchiving((prev) => ({
      ...prev,
      [vendorInvoiceNumber]: false,
    }));
  }
};
const loadArchivedInvoices = async () => {
  try {
    setLoading(true);

    const resp = await axios.get(
      `${Base_URL}/VendorInvoice/GetArchivedVendorInvoiceHeader/${user?.userId}`
    );

    setInvoices(Array.isArray(resp.data) ? resp.data : []);
  } catch (err) {
    toast.error("Failed to load archived invoices");
  } finally {
    setLoading(false);
  }
};
  const formatDate = (iso) => {
    if (!iso) return "-";
    try {
      return new Date(iso).toLocaleDateString();
    } catch (e) {
      return String(iso).split("T")[0];
    }
  };

  const fetchGstDataForItem = async (itemCode) => {
    if (!itemCode) return { CGST: 0, IGST: 0, SGST: 0 };
    try {
      const response = await axios.get(
        `${Base_URL}/VendorInvoice/GetGst?itemCode=${encodeURIComponent(itemCode)}`,
      );
      if (response.data) {
        const data = response.data;
        let gstRates = { CGST: 0, IGST: 0, SGST: 0 };
        if (data.CGST_Percent !== undefined) {
          gstRates = {
            CGST: parseFloat(data.CGST_Percent) || 0,
            IGST: parseFloat(data.IGST_Percent) || 0,
            SGST: parseFloat(data.SGST_Percent) || 0,
          };
        } else if (Array.isArray(data) && data.length > 0) {
          gstRates = {
            CGST: parseFloat(data[0].CGST_Percent) || 0,
            IGST: parseFloat(data[0].IGST_Percent) || 0,
            SGST: parseFloat(data[0].SGST_Percent) || 0,
          };
        } else if (data.cgsT_Percent !== undefined) {
          gstRates = {
            CGST: parseFloat(data.cgsT_Percent) || 0,
            IGST: parseFloat(data.igsT_Percent) || 0,
            SGST: parseFloat(data.sgsT_Percent) || 0,
          };
        }
        return gstRates;
      }
      return { CGST: 0, IGST: 0, SGST: 0 };
    } catch (error) {
      return { CGST: 0, IGST: 0, SGST: 0 };
    }
  };

  const calculateGstAmounts = (basicValue, cgstRate, igstRate, sgstRate) => {
    if (!basicValue)
      return { cgstAmount: 0, igstAmount: 0, sgstAmount: 0, totalAmount: 0 };
    const amount = parseFloat(basicValue);
    const cgstAmount = (amount * (cgstRate || 0)) / 100;
    const igstAmount = (amount * (igstRate || 0)) / 100;
    const sgstAmount = (amount * (sgstRate || 0)) / 100;
    const totalAmount = amount + cgstAmount + igstAmount + sgstAmount;
    return {
      cgstAmount: parseFloat(cgstAmount.toFixed(2)),
      igstAmount: parseFloat(igstAmount.toFixed(2)),
      sgstAmount: parseFloat(sgstAmount.toFixed(2)),
      totalAmount: parseFloat(totalAmount.toFixed(2)),
    };
  };

  const fetchInvoiceItems = async (vendorInvoiceNumber) => {
    try {
      setItemsLoading((prev) => ({ ...prev, [vendorInvoiceNumber]: true }));
      const url = `${Base_URL}/VendorInvoice/VendorInvoiceItems/id?id=${encodeURIComponent(vendorInvoiceNumber)}`;
      const resp = await axios.get(url);
      const data = Array.isArray(resp.data) ? resp.data : [];

      const itemsWithGst = await Promise.all(
        data.map(async (item) => {
          if (item.itemCode) {
            const gstRates = await fetchGstDataForItem(item.itemCode);
            const gstAmounts = calculateGstAmounts(
              item.basicValue || 0,
              gstRates.CGST,
              gstRates.IGST,
              gstRates.SGST,
            );
            return {
              ...item,
              cgstRate: gstRates.CGST,
              igstRate: gstRates.IGST,
              sgstRate: gstRates.SGST,
              calculatedCgstValue: gstAmounts.cgstAmount,
              calculatedIgstValue: gstAmounts.igstAmount,
              calculatedSgstValue: gstAmounts.sgstAmount,
              calculatedTotalValue: gstAmounts.totalAmount,
            };
          }
          return item;
        }),
      );

      setExpanded((prev) => ({ ...prev, [vendorInvoiceNumber]: itemsWithGst }));
    } catch (err) {
      toast.error("Failed to load vendor invoice items");
    } finally {
      setItemsLoading((prev) => ({ ...prev, [vendorInvoiceNumber]: false }));
    }
  };

  const handleRowClick = (vendorInvoiceNumber) => {
    if (expanded[vendorInvoiceNumber]) {
      setExpanded((prev) => {
        const copy = { ...prev };
        delete copy[vendorInvoiceNumber];
        return copy;
      });
    } else {
      fetchInvoiceItems(vendorInvoiceNumber);
    }
  };

  const handlePost = async (vendorInvoiceNumber) => {
    try {
      setPosting((prev) => ({ ...prev, [vendorInvoiceNumber]: true }));
      await axios.put(
        `${Base_URL}/VendorInvoice/id?id=${encodeURIComponent(vendorInvoiceNumber)}`,
      );
      toast.success(`Invoice ${vendorInvoiceNumber} posted successfully!`);
      setInvoices((prev) =>
        prev.map((inv) =>
          inv.vendorInvoice.vendorInvoiceNumber === vendorInvoiceNumber
            ? {
                ...inv,
                vendorInvoice: { ...inv.vendorInvoice, postedStatus: "Yes" },
              }
            : inv,
        ),
      );
    } catch (err) {
      toast.error(
        `Failed to post invoice ${vendorInvoiceNumber}: ${err.response?.data || err.message}`,
      );
    } finally {
      setPosting((prev) => ({ ...prev, [vendorInvoiceNumber]: false }));
    }
  };

  const handleReversalConfirm = async () => {
    if (!selectedInvoice) return;
    try {
      setReversing(true);
      const payload = {
        source: "Vendor invoice reversal",
        referenceNo: selectedInvoice,
        userId: user?.userId,
        orgId: user?.organisationId,
      };
      await axios.post(
        `${Base_URL}/VendorInvoice/vendorInvoiceReversal`,
        payload,
      );
      toast.success(`Invoice ${selectedInvoice} reversed successfully`);
      setShowModal(false);
      setSelectedInvoice(null);
    } catch (err) {
      toast.error(err.response?.data || "Failed to reverse invoice");
    } finally {
      setReversing(false);
    }
  };
const handleUnarchive = async (vendorInvoiceNumber) => {
  try {
    setUnarchiving((prev) => ({
      ...prev,
      [vendorInvoiceNumber]: true,
    }));

    await axios.put(
      `${Base_URL}/VendorInvoice/unarchiveVendorInvice?id=${encodeURIComponent(
        vendorInvoiceNumber
      )}&userId=${user?.userId}`
    );

    toast.success(
      `Invoice ${vendorInvoiceNumber} unarchived successfully`
    );

    await loadArchivedInvoices();
  } catch (err) {
    toast.error(
      err.response?.data ||
      `Failed to unarchive invoice ${vendorInvoiceNumber}`
    );
  } finally {
    setUnarchiving((prev) => ({
      ...prev,
      [vendorInvoiceNumber]: false,
    }));
  }
};
  const filteredInvoices = invoices.filter((inv) => {
    const invoiceNo =
      inv?.vendorInvoice?.vendorInvoiceNumber?.toLowerCase() || "";

    const vendorName = inv?.vendor?.name?.toLowerCase() || "";

    const invoiceType = inv?.vendorInvoice?.invoiceType?.toLowerCase() || "";

    const posted = String(inv?.vendorInvoice?.postedStatus)?.toLowerCase();

    const reversed = String(inv?.vendorInvoice?.reversalStatus)?.toLowerCase();

    const createdDate = inv?.vendorInvoice?.createdOn
      ? new Date(inv.vendorInvoice.createdOn)
      : null;

    const matchesInvoice = invoiceNo.includes(searchInvoice.toLowerCase());

    const matchesVendor = vendorName.includes(searchVendor.toLowerCase());

    const matchesType =
      !invoiceTypeFilter || invoiceType === invoiceTypeFilter.toLowerCase();

    const matchesPosted =
      !postedFilter || posted === postedFilter.toLowerCase();

    const matchesReversed =
      !reversedFilter || reversed === reversedFilter.toLowerCase();

    const matchesFromDate =
      !fromDate || (createdDate && createdDate >= new Date(fromDate));

    const matchesToDate =
      !toDate || (createdDate && createdDate <= new Date(toDate));

    return (
      matchesInvoice &&
      matchesVendor &&
      matchesType &&
      matchesPosted &&
      matchesReversed &&
      matchesFromDate &&
      matchesToDate
    );
  });

  return (
    <div className="vil-page">
      <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
        {/* ── Header ── */}
        <div className="vil-header">
          <h1 className="vil-title">Vendor Invoices</h1>
          <ul className="vil-actions">
            <li
              className="vil-action-link"
              onClick={() => navigate("/vendorInvoices")}
            >
              + Create Invoice With PO
            </li>
            <li
              className="vil-action-link"
              onClick={() => navigate("/vendorInvoiceWithoutPO")}
            >
              + Create Invoice Without PO
            </li>
            <li
  className="vil-action-link"
  onClick={async () => {
    setShowArchived(false);
    await loadInvoices();
  }}
>
  Active Invoices
</li>

<li
  className="vil-action-link"
  onClick={async () => {
    setShowArchived(true);
    await loadArchivedInvoices();
  }}
>
  Archived Invoices
</li>
          </ul>
        </div>

<div
  className="vil-filters"
  style={{
    display: "flex",
    gap: "10px",
    flexWrap: "wrap",
    alignItems: "center",
    marginBottom: "15px",
  }}
>
  <input
    type="text"
    placeholder="Invoice No"
    value={searchInvoice}
    onChange={(e) => setSearchInvoice(e.target.value)}
    className="form-control"
    style={{ maxWidth: "160px" }}
  />

  <input
    type="text"
    placeholder="Vendor"
    value={searchVendor}
    onChange={(e) => setSearchVendor(e.target.value)}
    className="form-control"
    style={{ maxWidth: "180px" }}
  />

<div style={{ position: "relative", maxWidth: "160px" }}>
  <select
    value={postedFilter}
    onChange={(e) => setPostedFilter(e.target.value)}
    className="form-control"
    style={{
      appearance: "none",
      WebkitAppearance: "none",
      MozAppearance: "none",
      paddingRight: "35px",
    }}
  >
    <option value="">All Posted</option>
    <option value="yes">Posted</option>
    <option value="no">Not Posted</option>
  </select>

  <FaChevronDown
    style={{
      position: "absolute",
      right: "12px",
      top: "50%",
      transform: "translateY(-50%)",
      pointerEvents: "none",
      color: "#666",
      fontSize: "12px",
    }}
  />
</div>

<div style={{ position: "relative", maxWidth: "170px" }}>
  <select
    value={reversedFilter}
    onChange={(e) => setReversedFilter(e.target.value)}
    className="form-control"
    style={{
      appearance: "none",
      WebkitAppearance: "none",
      MozAppearance: "none",
      paddingRight: "35px",
    }}
  >
    <option value="">All Reversed</option>
    <option value="yes">Reversed</option>
    <option value="no">Not Reversed</option>
  </select>

  <FaChevronDown
    style={{
      position: "absolute",
      right: "12px",
      top: "50%",
      transform: "translateY(-50%)",
      pointerEvents: "none",
      color: "#666",
      fontSize: "12px",
    }}
  />
</div>

  <input
    type="text"
    placeholder="Invoice Type"
    value={invoiceTypeFilter}
    onChange={(e) => setInvoiceTypeFilter(e.target.value)}
    className="form-control"
    style={{ maxWidth: "170px" }}
  />

  <input
    type="date"
    value={fromDate}
    onChange={(e) => setFromDate(e.target.value)}
    className="form-control"
    style={{ maxWidth: "170px" }}
  />

  <input
    type="date"
    value={toDate}
    onChange={(e) => setToDate(e.target.value)}
    className="form-control"
    style={{ maxWidth: "170px" }}
  />
</div>
        {/* ── Table Card ── */}
        <div className="vil-card">
          <table className="vil-table">
            <thead>
              <tr>
                <th>Vendor Invoice</th>
                <th>Vendor Name</th>
                <th>Purchase Order</th>
                <th>External Invoice No.</th>
                <th>Company Code</th>
                <th>Invoice Type</th>
                <th>Posted</th>
                <th>Reversed</th>

                <th>Invoice Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {/* Loading */}
              {loading && (
                <tr className="vil-state-row">
                  <td colSpan={9}>
                    <span className="vil-loading-spinner" />
                    Loading invoices…
                  </td>
                </tr>
              )}

              {/* Empty */}
              {!loading && invoices.length === 0 && (
                <tr className="vil-state-row">
                  <td colSpan={9}>No invoices found</td>
                </tr>
              )}

              {/* Data rows */}
              {!loading &&
                filteredInvoices.map((inv, idx) => {
                  const invNum = inv?.vendorInvoice?.vendorInvoiceNumber;
                  const isArchived = inv?.vendorInvoice?.active === false;
                  const isExpanded = !!expanded[invNum];
                  const isPosted =
                    String(inv?.vendorInvoice?.postedStatus)?.toLowerCase() ===
                    "yes";
                  const isReversed =
                    String(
                      inv?.vendorInvoice?.reversalStatus,
                    )?.toLowerCase() === "yes";

                  return (
                    <React.Fragment key={idx}>
                      <tr
                        className="vil-row"
                        onClick={(e) => {
                          if (e.target.closest("button")) return;
                          handleRowClick(invNum);
                        }}
                      >
                        <td>
                          <span className="vil-invoice-num">
                            {invNum ?? "-"}
                          </span>
                        </td>
                        <td>
                          <span className="vil-vendor-name">
                            {inv?.vendor?.name ?? "-"}
                          </span>
                        </td>
                        <td>
                          {inv?.vendorInvoice?.purchaseOrderNumber ?? "-"}
                        </td>
                        <td>
                          {inv?.vendorInvoice?.externalInvoiceNumber ?? "-"}
                        </td>
                        <td>{String(inv?.company?.name ?? "-")}</td>
                        <td>{inv?.vendorInvoice?.invoiceType ?? "-"}</td>
                        <td>
                          {isPosted ? (
                            <span className="vil-badge vil-badge--yes">
                              Yes
                            </span>
                          ) : (
                            <span className="vil-badge vil-badge--no">No</span>
                          )}
                        </td>
                        <td>
                          {isReversed ? (
                            <span className="vil-badge vil-badge--yes">
                              Yes
                            </span>
                          ) : (
                            <span className="vil-badge vil-badge--no">No</span>
                          )}
                        </td>
                        <td>{formatDate(inv?.vendorInvoice?.createdOn)}</td>
                        <td onClick={(e) => e.stopPropagation()}>
                          <div className="vil-actions-cell">
                            {/* Post Button */}
                          <button
  className={`vil-btn ${
    isArchived
      ? "vil-btn--posted"
      : isPosted
      ? "vil-btn--posted"
      : posting[invNum]
      ? "vil-btn--posting"
      : "vil-btn--post"
  }`}
  onClick={() => handlePost(invNum)}
  disabled={isArchived || isPosted || posting[invNum]}
>
  {isArchived
    ? "Archived"
    : posting[invNum]
    ? "Posting..."
    : isPosted
    ? "Posted"
    : "Post"}
</button>

                            {/* Edit Button */}
                           <button
                      className="vil-btn vil-btn--edit"
                      disabled={isPosted || isReversed}
                      onClick={() => navigate(`/editVendorInvoice/${invNum}`)}
                    >
                  Edit
                </button>
                              {/* Archive/Unarchive Button */}
                              {showArchived ? (
  <button
    className="vil-btn vil-btn--archive"
    onClick={() => handleUnarchive(invNum)}
    disabled={unarchiving[invNum]}
  >
    {unarchiving[invNum] ? "Unarchiving..." : "Unarchive"}
  </button>
) : (
  <button
    className="vil-btn vil-btn--archive"
    onClick={() => handleArchive(invNum)}
    disabled={
      archiving[invNum] ||
      isPosted ||
      isReversed
    }
  >
    {archiving[invNum] ? "Archiving..." : "Archive"}
  </button>
)}

                            {/* Reverse Button */}
                            <button
                              className="vil-btn vil-btn--reverse"
                              disabled={isReversed}
                              onClick={(e) => {
                                e.stopPropagation();
                                setSelectedInvoice(invNum);
                                setShowModal(true);
                              }}
                            >
                              Reverse
                            </button>
                          </div>
                        </td>
                      </tr>

                      {/* Expanded sub-row */}
                      {isExpanded && (
                        <tr className="vil-expanded-row">
                          <td colSpan={9}>
                            {itemsLoading[invNum] ? (
                              <div className="vil-sub-loading">
                                <span className="vil-loading-spinner" />
                                Loading items…
                              </div>
                            ) : (
                              <div className="vil-expanded-inner">
                                <h4>Invoice Items &amp; GST Breakdown</h4>
                                <table className="vil-sub-table">
                                  <thead>
                                    <tr>
                                      <th>Item Code</th>
                                      <th>Description</th>
                                      <th>Orig. Qty</th>
                                      <th>Recv. Qty</th>
                                      <th>Inv. Qty</th>
                                      <th>Balance</th>
                                      <th>Unit</th>
                                      <th>Price</th>
                                      <th>Basic Value</th>
                                      <th>CGST %</th>
                                      <th>CGST Value</th>
                                      <th>SGST %</th>
                                      <th>SGST Value</th>
                                      <th>IGST %</th>
                                      <th>IGST Value</th>
                                      <th>Total Value</th>
                                      <th>Receipt Date</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {expanded[invNum]?.map(
                                      (item, itemIndex) => (
                                        <tr key={itemIndex}>
                                          <td className="item-code">
                                            {item.itemCode}
                                          </td>
                                          <td>{item.description}</td>
                                          <td className="text-right">
                                            {item.originalQuantity}
                                          </td>
                                          <td className="text-right">
                                            {item.quantityReceived}
                                          </td>
                                          <td className="text-right">
                                            {item.invoiceQuantity}
                                          </td>
                                          <td className="text-right">
                                            {item.balanceQuantity}
                                          </td>
                                          <td>{item.unit}</td>
                                          <td className="text-right">
                                            {item.price?.toFixed(2)}
                                          </td>
                                          <td className="text-right">
                                            {item.basicValue?.toFixed(2)}
                                          </td>
                                          <td className="text-right cgst-cell">
                                            {item.cgst?.toFixed(2)}%
                                          </td>
                                          <td className="text-right cgst-cell">
                                            {item.cgstValue?.toFixed(2)}
                                          </td>
                                          <td className="text-right sgst-cell">
                                            {item.sgst?.toFixed(2)}%
                                          </td>
                                          <td className="text-right sgst-cell">
                                            {item.sgstValue?.toFixed(2)}
                                          </td>
                                          <td className="text-right igst-cell">
                                            {item.igst?.toFixed(2)}%
                                          </td>
                                          <td className="text-right igst-cell">
                                            {item.igstValue?.toFixed(2)}
                                          </td>
                                          <td className="text-right total-cell">
                                            {(
                                              (Number(item.basicValue) || 0) +
                                              (Number(
                                                item.sgstValue ??
                                                  item.calculatedSgstValue ??
                                                  item.sgst ??
                                                  0,
                                              ) || 0) +
                                              (Number(
                                                item.cgstValue ??
                                                  item.calculatedCgstValue ??
                                                  item.cgst ??
                                                  0,
                                              ) || 0) +
                                              (Number(
                                                item.igstValue ??
                                                  item.calculatedIgstValue ??
                                                  item.igst ??
                                                  0,
                                              ) || 0)
                                            ).toFixed(2)}
                                          </td>
                                          <td>
                                            {formatDate(item.receiptDate)}
                                          </td>
                                        </tr>
                                      ),
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })}
            </tbody>
          </table>
        </div>

        {error && <div className="vil-error">{error}</div>}
      </div>

      {/* ── Reversal Confirmation Modal (Portal) ── */}
      {showModal &&
        createPortal(
          <div className="vil-modal-overlay">
            <div className="vil-modal">
              {/* Warning Icon */}
              <div className="vil-modal__icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                  <line x1="12" y1="9" x2="12" y2="13" />
                  <line x1="12" y1="17" x2="12.01" y2="17" />
                </svg>
              </div>

              <h2 className="vil-modal__title">Confirm Reversal</h2>
              <p className="vil-modal__body">
                Are you sure you want to reverse the posting for invoice{" "}
                <strong>{selectedInvoice}</strong>? This action cannot be
                undone.
              </p>

              <div className="vil-modal__footer">
                <button
                  className="vil-modal__btn vil-modal__btn--cancel"
                  onClick={() => {
                    setShowModal(false);
                    setSelectedInvoice(null);
                  }}
                >
                  Cancel
                </button>
                <button
                  className="vil-modal__btn vil-modal__btn--confirm"
                  onClick={handleReversalConfirm}
                  disabled={reversing}
                >
                  {reversing ? "Reversing…" : "Yes, Reverse"}
                </button>
              </div>
            </div>
          </div>,
          document.body,
        )}
    </div>
  );
}
